import { Box, Paper, Typography, Avatar, Chip } from '@mui/material';

import { useCallback, useState } from 'react';

import { Loader } from 'common/components/Loader/Loader';
import CommonTable from 'common/components/Table/CommonTable';
import { Column } from 'common/components/Table/CommonTableStyles';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import {
	formatAssigneeName,
	getCurrentDate,
	dateInCorrectFormatWithFullYear,
	dateFullYearFormat,
} from 'common/utils/utilFunctions';

import styles from './PendingActionItemsTable.module.scss';

const PendingActionItemsTable = ({ pendingActionsData }: any) => {
	const [toastMessage, setToastMessageLocal] = useState('');
	const [isLoading] = useState<boolean>(false);
	const [isToastOpen, setIsToastOpen] = useState(false);
	const handleToast = useCallback(() => {
		setIsToastOpen(false);
		setToastMessageLocal('');
	}, []);

	const columns: readonly Column[] = [
		{
			id: 'testPhase',
			label: 'Phase',
			disablePadding: false,
			isSortable: true,
			render: (params: any) =>
				params?.testPhase ? (
					<Typography
						component="div"
						className={styles['pending-action-table-task-name']}
					>
						{params?.testPhase}
					</Typography>
				) : (
					<div>--</div>
				),
		},
		{
			id: 'actionType',
			label: 'Type of Action',
			disablePadding: false,
			isSortable: true,
			render: (params: any) =>
				params?.actionType ? (
					<Typography
						component="div"
						className={styles['pending-action-table-task-name']}
					>
						{params?.actionType}
					</Typography>
				) : (
					<div>--</div>
				),
		},
		{
			id: 'actionItemName',
			label: 'Action Item Name',
			disablePadding: false,
			isSortable: true,
			render: (params: any) =>
				params?.actionItemName ? (
					<Typography
						component="div"
						className={styles['pending-action-table-task-name']}
					>
						{params?.actionItemName}
					</Typography>
				) : (
					<div>--</div>
				),
		},
		{
			id: 'dateReceived',
			label: 'Date Received',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>
					{params?.dateReceived
						? dateFullYearFormat(params?.dateReceived)
						: '--'}
				</div>
			),
		},
		{
			id: 'dueDate',
			label: 'Due Date',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<div className={styles['pending-action-table-date']}>
					{params?.dueDate ? (
						<div className={styles['pending-action-table-display']}>
							{dateFullYearFormat(params?.dueDate)}
							<div className={styles['pending-action-table-chip']}>
								{dateInCorrectFormatWithFullYear(params?.dueDate) >
								dateInCorrectFormatWithFullYear(getCurrentDate()) ? (
									<Chip
										className={styles['pending-action-table-chip-color']}
										data-testid="overduedate-link"
										label="Due"
										color="error"
										variant="outlined"
										size="medium"
									/>
								) : (
									<Chip
										className={styles['pending-action-table-chip-color']}
										data-testid="duedate-link"
										label="Overdue"
										color="error"
										variant="outlined"
										size="medium"
									/>
								)}{' '}
							</div>
						</div>
					) : (
						'--'
					)}
				</div>
			),
		},
		{
			id: 'initiatorName',
			label: 'Initiator',
			disablePadding: false,
			isSortable: true,
			render: (params: any) =>
				params.initiatorName ? (
					<Avatar className={styles['pending-action-table-cell-avatar']}>
						{formatAssigneeName(params.initiatorName)}
					</Avatar>
				) : (
					<div>--</div>
				),
		},
		{
			id: 'ownerName',
			label: 'Owner',
			disablePadding: false,
			isSortable: true,
			render: (params: any) =>
				params.ownerName ? (
					<Avatar className={styles['pending-action-table-cell-avatar']}>
						{formatAssigneeName(params.ownerName)}
					</Avatar>
				) : (
					<div>--</div>
				),
		},
		{
			id: 'status',
			label: 'Status',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.status ? params?.status : '--'}</div>
			),
		},
		{
			id: 'impactedTests',
			label: 'Impacted Tests',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.ImpactedTests ? params?.ImpactedTests : '--'}</div>
			),
		},
	];
	return (
		<Box className={styles['pending-action-table-box']}>
			{pendingActionsData && pendingActionsData.length > 0 && !isLoading ? (
				<CommonTable
					id="PendingActionItemsTable"
					rows={pendingActionsData}
					columns={columns}
					defaultSortKey=""
					tableStyles={{ minWidth: 750, maxHeight: 440 }}
				/>
			) : (
				<div>
					{!isLoading ? (
						<Paper className={styles['pending-action-table-loading-box']}>
							<Typography data-testid="no-data-found">No data found</Typography>
						</Paper>
					) : (
						<Paper className={styles['pending-action-table-loading-box']}>
							<Loader show={false} />
						</Paper>
					)}
				</div>
			)}
			<AlertComponent
				open={isToastOpen}
				toastMessage={toastMessage}
				severity="error"
				handleCloseMessage={handleToast}
				vertical="top"
				horizontal="right"
			/>
		</Box>
	);
};

export default PendingActionItemsTable;
